export class PaymentProviderCallbackDto {

  public readonly success!: boolean;
  public readonly mediaId: string | undefined;

  constructor(init?: Partial<PaymentProviderCallbackDto> | undefined) {
    Object.assign(this, init);
  }
}
